import * as loaders from "@lts/loaders/legacy/legacy-glTF2FileLoader";
export { loaders };
export default loaders;
